import { render } from "./p-modal.vue?vue&type=template&id=6e8105a0"
import script from "./p-modal.vue?vue&type=script&lang=js"
export * from "./p-modal.vue?vue&type=script&lang=js"

import "./p-modal.vue?vue&type=style&index=0&id=6e8105a0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e8105a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e8105a0', __exports__)) {
    api.reload('6e8105a0', __exports__)
  }
  
  module.hot.accept("./p-modal.vue?vue&type=template&id=6e8105a0", () => {
    api.rerender('6e8105a0', render)
  })

}


export default __exports__